<template>
  <b-form-group label="UF:">
    <b-form-select
      v-model="valor"
      :options="estados"
      @change="buscaCidades"
    ></b-form-select>
  </b-form-group>
</template>

<style lang="scss" scoped></style>

<script>
import { mapActions } from "vuex";
import estados from "./estados.json";

export default {
  name: "InputEstado",
  data() {
    return {
      estados: estados
    };
  },
  computed: {
    valor: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  props: ["value"],
  methods: {
    ...mapActions(["getCidades"]),
    async buscaCidades() {
      let cidades = await this.getCidades(this.valor);
      this.$emit("buscacidades", cidades);
    }
  }
};
</script>
